import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';

const styles = () => ({
    listView: {
        marginBottom: '20px',
    },
    title: {
        color: COLORS.LT_MIDNIGHT,
        marginBottom: '20px',
        fontWeight: '800',
    },
});

function ListViewTable({ children, classes, title = '' }) {
    return (
        <div className={classes.listView}>
            {title !== '' && (
                <Typography variant="body1" component="p" className={classes.title}>
                    {title}
                </Typography>
            )}
            {children}
        </div>
    );
}

export default withStyles(styles)(ListViewTable);
